const context = new AudioContext();
let yodelBuffer;

fetch("audio_bientot.mp3")
    .then((response) => response.arrayBuffer())
    .then((arrayBuffer) => context.decodeAudioData(arrayBuffer))
    .then((audioBuffer) => {
        yodelBuffer = audioBuffer;
    });
function play(audioBuffer) {
    const source = context.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(context.destination);
    source.start();
}
function audio_bientot_func() {
    play(yodelBuffer);
}

export {
    audio_bientot_func,
    yodelBuffer,
    context
}